<template>
    
    <div id="geo-map-container">
        <div :id="containerId"></div>
    </div>
</template>

<script>

    import { mapState, mapMutations } from "vuex";
    import "@/../node_modules/echarts/extension/bmap/bmap";
    import BMap from "BMap";
    import BMapLib from "BMapLib";

    import NanshaDistrictJSON from "@/data/nansha-district.json";

    export default {
        name: "GeoMap",
        props: {
            platformData: {
                type: Array
            },
            axisData: {
                type: Array
            },
            enterpriseData: {
                type: Array
            },
            nodeData: {
                type: Array
            },
            areaData: {
                type: Array
            },
            nanshaData: {
                type: Array
            }
        },
        data() {
            return {
                containerId: "geo-map",
                chart: null,
                tmpInterval: null,
                app: {},
                // isClickTooltip: true,
            };
        },
        computed: {
            ...mapState(["tOption", "selectedPlatform", "selectedEnterprise", "tData"])
        },
        mounted() {
            this.initMap();
        },
        methods: {
            ...mapMutations(["updatazoneData", "updateShowZoon"]),
            initMap() {

                const chartDom = document.getElementById(this.containerId);

                this.chart = this.$echarts.init(chartDom);

                this.drawMap();

            },
           
            drawMap() {

                this.$echarts.registerMap("NanshaDistrict", NanshaDistrictJSON);

                const option = {
                    ...this.getDefaultOption()
                };

                this.chart.setOption(option);

                this.mapModel = this.chart.getModel().getComponent('bmap').getBMap();

                this.mapModel.addControl(new BMap.NavigationControl());
            },
            // series中的配置项顺序不能乱
            getDefaultOption() {

                return {
                    bmap: {
                        center: [113.570619, 22.762842],
                        zoom: 11,
                        roam: true, //允许缩放
                        mapStyle: {
                            styleJson: [
                                {
                                    featureType: 'water',
                                    elementType: 'all',
                                    stylers: {
                                        color: '#191c85'
                                    }
                                },
                                {
                                    featureType: 'land',
                                    elementType: 'all',
                                    stylers: {
                                        color: '#00057d'
                                    }
                                },
                                {
                                    featureType: 'railway',
                                    elementType: 'all',
                                    stylers: {
                                        visibility: 'off'
                                    }
                                },
                                {
                                    featureType: 'highway',
                                    elementType: 'all',
                                    stylers: {
                                        color: '#191c85'
                                    }
                                },
                                {
                                    featureType: 'highway',
                                    elementType: 'labels',
                                    stylers: {
                                        visibility: 'off'
                                    }
                                },
                                {
                                    featureType: 'arterial',
                                    elementType: 'geometry',
                                    stylers: {
                                        color: '#191c85'
                                    }
                                },
                                {
                                    featureType: 'arterial',
                                    elementType: 'geometry.fill',
                                    stylers: {
                                        color: '#191c85'
                                    }
                                },
                                {
                                    featureType: 'poi',
                                    elementType: 'all',
                                    stylers: {
                                        visibility: 'off'
                                    }
                                },
                                {
                                    featureType: 'green',
                                    elementType: 'all',
                                    stylers: {
                                        visibility: 'off'
                                    }
                                },
                                {
                                    featureType: 'subway',
                                    elementType: 'all',
                                    stylers: {
                                        visibility: 'off'
                                    }
                                },
                                {
                                    featureType: 'manmade',
                                    elementType: 'all',
                                    stylers: {
                                        color: '#191c85'
                                    }
                                },
                                {
                                    featureType: 'local',
                                    elementType: 'all',
                                    stylers: {
                                        color: '#191c85'
                                    }
                                },
                                {
                                    featureType: 'arterial',
                                    elementType: 'labels',
                                    stylers: {
                                        visibility: 'off'
                                    }
                                },
                                {
                                    featureType: 'boundary',
                                    elementType: 'all',
                                    stylers: {
                                        color: '#191c85'
                                    }
                                },
                                {
                                    featureType: 'building',
                                    elementType: 'all',
                                    stylers: {
                                        color: '#191c85'
                                    }
                                },
                                {
                                    featureType: 'label',
                                    elementType: 'labels.text.fill',
                                    stylers: {
                                        color: '#6fa2e7',
                                    }
                                },
                                {
                                    featureType: 'label',
                                    elementType: 'labels.text.stroke',
                                    stylers: {
                                        color: '#050782',
                                    }
                                },
                            ]
                        }
                    }
                };
            },
            updateDataHelper(el) {

                const { name, coord } = el;
                    
                return coord.concat(10).concat(name);
            },
            getPlatformOption(sData) {

                const updatedData = sData || this.platformData;

                const seriesData = updatedData?.map(el => this.updateDataHelper(el));

                // const coreData = this.axisData?.map(el => this.updateDataHelper(el));

                return {
                    ...this.getDefaultOption(),
                    tooltip: {
                        trigger: "item",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        borderWidth: 0,
                        position: this.calculatePosition,
                        formatter(params) {

                            const { data } = params;
                            // if(data[data.length - 1] == "南沙科学城创新核心") {
                            //     return ''
                            // }

                            data.length - 1

                            const color = "#10FFB3";

                            const styleText = [
                                `border-left: 4px solid ${color}`,
                                "padding-left: 0.5rem",
                                `color: ${color}`,
                                "max-width: 11rem",
                                "word-wrap: break-word !important",
                                "white-space: normal !important",
                                "word-break: break-all !important"
                            ].join(";");

                            return `<div style='${styleText}'>${data[data.length - 1]}</div>`;
                        }
                    },
                    series: [
                        
                        {
                            type: 'custom',
                            coordinateSystem: 'bmap',
                            renderItem: this.renderItem4,
                            itemStyle: {
                                color: "rgba(255,255,255, 0)",
                                borderColor: "rgba(255, 255, 255, 1)",
                                borderWidth: 2
                            },
                            animation: true,
                            silent: true,
                            data: [0],
                            z: -10
                        },
                        {
                            type: 'custom',
                            coordinateSystem: 'bmap',
                            renderItem: this.renderItem5,
                            itemStyle: {
                                color: "rgba(255,255,255, 0)",
                                borderColor: "rgba(255, 255, 255, 1)",
                                borderWidth: 2
                            },
                            animation: true,
                            silent: true,
                            data: [0],
                            z: -10
                        },
                        {
                            type: "effectScatter",
                            coordinateSystem: "bmap",
                            data: seriesData,
                            symbol: "image://https://s3.bmp.ovh/imgs/2022/06/24/ed326ae872c0bcd1.png",
                            symbolSize: 15,
                            label: {
                                show: false,
                                position: 'top',
                                formatter: function(params) {
                                    // console.log('aaaaa', params)
                                    return params.data[3]
                                    // return `<p style="backgroud: red">aaaaaa</p>`
                                }
                            },
                            emphasis: {
                                disabled: false,
                                scale: 3,
                                focus: "self"
                            }
                        },
                        //  { 
                        //     type: "effectScatter",
                        //     coordinateSystem: "bmap",
                        //     data: coreData,
                        //     symbol: "image://https://s3.bmp.ovh/imgs/2022/06/21/850cf1c5408d363f.png",
                        //     symbolSize: 50,
                        //     symbolKeepAspect: true,
                        // },
                        //  { type: "scatter",
                        //     coordinateSystem: "bmap",
                        //     data: coreData,
                        //     symbol: "image://https://s3.bmp.ovh/imgs/2022/06/28/f8267bfc2cf4df96.png",
                        //     symbolSize: 500,
                        //     z: -20},
                    ]
                };
            },
            getAxisOption(sData) {

                const updatedData = sData || this.axisData;

                const seriesData = updatedData?.map(el => this.updateDataHelper(el));

                const coreData = updatedData?.map(el => this.updateDataHelper(el));

                return {
                    ...this.getDefaultOption(),

                    series: [
                       
                         {
                            type: 'custom',
                            coordinateSystem: 'bmap',
                            renderItem: this.renderItem4,
                            itemStyle: {
                                color: "rgba(255,255,255, 0)",
                                borderColor: "rgba(255, 255, 255, 1)",
                                borderWidth: 2
                            },
                            animation: true,
                            silent: true,
                            data: [0],
                            z: -10
                        },
                        {
                            type: 'custom',
                            coordinateSystem: 'bmap',
                            renderItem: this.renderItem5,
                            itemStyle: {
                                color: "rgba(255,255,255, 0)",
                                borderColor: "rgba(255, 255, 255, 1)",
                                borderWidth: 2
                            },
                            animation: true,
                            silent: true,
                            data: [0],
                            z: -10
                        },
                        { type: "scatter",
                        coordinateSystem: "bmap",
                        data: seriesData,
                        symbol: "image://https://s3.bmp.ovh/imgs/2022/06/24/1920115f2ede9c4e.png",
                        symbolSize: 400},
                        { 
                            type: "effectScatter",
                            coordinateSystem: "bmap",
                            data: coreData,
                            symbol: "image://https://s3.bmp.ovh/imgs/2022/06/21/850cf1c5408d363f.png",
                            symbolSize: 50,
                            symbolKeepAspect: true,
                        },
                    ]
                };
            },
            getEnterpriseOption(sData) {

                const updatedData = sData || this.enterpriseData;

                // const coreData = this.axisData?.map(el => this.updateDataHelper(el));

                const data1 = [];
                const data2 = [];

                updatedData.forEach(entry => {

                    const { name, coord, category } = entry;

                    const colorCode = category.includes("专精特新企业库")? "#A3FF90" : "#FD6481";

                    const coordData =  [...coord, colorCode, name];

                    if (category.split(",").length > 1 || category.includes("专精特新企业库")) {
                        data2.push(coordData);
                    } else {
                        data1.push(coordData);
                    }
                });

                return {
                    ...this.getDefaultOption(),
                    tooltip: {
                        trigger: "item",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        borderWidth: 0,
                        position: this.calculatePosition,
                        formatter(params) {

                            const { data } = params;

                            console.log(data[data.length - 1], '0000000000');

                            // if(data[data.length - 1] == "南沙科学城创新核心") {
                            //     return ''
                            // }

                            const color = data[2];

                            const styleText = [
                                `border-left: 4px solid ${color}`,
                                "padding-left: 0.5rem",
                                `color: ${color}`,
                                "max-width: 11rem",
                                "word-wrap: break-word !important",
                                "white-space: normal !important",
                                "word-break: break-all !important"
                            ].join(";");

                            return `<div style='${styleText}'>${data[data.length - 1]}</div>`;
                        }
                    },
                    series: [
                         {
                            type: 'custom',
                            coordinateSystem: 'bmap',
                            renderItem: this.renderItem4,
                            itemStyle: {
                                color: "rgba(255,255,255, 0)",
                                borderColor: "rgba(255, 255, 255, 1)",
                                borderWidth: 2
                            },
                            animation: true,
                            silent: true,
                            data: [0],
                            z: -20
                        },
                        {
                            type: 'custom',
                            coordinateSystem: 'bmap',
                            renderItem: this.renderItem5,
                            itemStyle: {
                                color: "rgba(255,255,255, 0)",
                                borderColor: "rgba(255, 255, 255, 1)",
                                borderWidth: 2
                            },
                            animation: true,
                            silent: true,
                            data: [0],
                            z: -20
                        },
                        {
                            type: "scatter",
                            coordinateSystem: "bmap",
                            data: data1,
                            symbolSize: 8,
                            itemStyle: {
                                color: "#FD6481"
                            },
                            label: {
                                show: false,
                                position: 'top',
                                formatter: function (params) {
                                    // console.log('aaa', params.data[3])
                                    return params.data[3]
                                }
                            },
                            emphasis: {
                                disabled: false,
                                scale: 2,
                                focus: "self"
                            }
                        },
                        //  { 
                        //     type: "effectScatter",
                        //     coordinateSystem: "bmap",
                        //     data: coreData,
                        //     symbol: "image://https://s3.bmp.ovh/imgs/2022/06/21/850cf1c5408d363f.png",
                        //     symbolSize: 50,
                        //     symbolKeepAspect: true,
                        // },
                        //  { type: "scatter",
                        //     coordinateSystem: "bmap",
                        //     data: coreData,
                        //     symbol: "image://https://s3.bmp.ovh/imgs/2022/06/28/f8267bfc2cf4df96.png",
                        //     symbolSize: 500,
                        //     z: -20},
                        {
                            type: "scatter",
                            coordinateSystem: "bmap",
                            data: data2,
                            itemStyle: {
                                color: "#A3FF90"
                            },
                            symbolSize: 8,
                            emphasis: {
                                disabled: false,
                                scale: 2,
                                focus: "self"
                            }
                        }
                    ]
                };
            },
            getAreaOption(nData) {

                const updatedNodeData = nData || this.nodeData;
                // console.log(updatedNodeData, '----------');
                const coreData = this.axisData?.map(el => this.updateDataHelper(el));
                const seriesNodeData = updatedNodeData?.map(el => {

                    const { name, desc } = el;

                    const tmp = this.updateDataHelper(el);

                    const tmpData = tmp.slice(0, tmp.length - 1); 

                    return tmpData.concat(desc).concat(name);
                });

                const color = "#FCD048";

                return {
                    ...this.getDefaultOption(),
                    
                    tooltip: {
                        trigger: "item",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        borderWidth: 0,
                        position: this.calculatePosition,
                        formatter(params) {

                            const { data } = params;

                            const desc = data[3];

                            // console.log(data, '------------------------');
                            if(data[data.length - 1] == "南沙科学城创新核心") {
                                return ''
                            }

                            const styleText = [
                                `border-left: 4px solid ${color}`,
                                "padding-left: 0.5rem",
                                `color: ${color}`
                            ].join(";");

                            const styleText1 = [
                                `background-color: ${color}`,
                                "color: black",
                                "padding-left: 0.5rem",
                                "margin-top: 0.5rem",
                                "border-radius: 0rem 0rem 3rem 0rem"
                            ].join(";");

                            const styleText2 = [
                                "color: white",
                                "padding-left: 0.5rem",
                                "margin-top: 0.5rem",
                                "font-size: 12px",
                                "letter-spacing: 0.1rem",
                                "width: inherit",
                                "min-width: 7rem",
                                "word-wrap: break-word !important",
                                "white-space: normal !important",
                                "word-break: break-all !important"
                            ].join(";");

                            const html = desc? `
                                <div style="min-width: 7rem">
                                    <div style='${styleText}'>
                                        ${data[data.length - 1]}
                                    </div>
                                    <div style='${styleText1}'>
                                        产业发展方向
                                    </div>
                                    <div style='${styleText2}'>
                                        ${desc}
                                    </div>
                                </div>
                            ` : 
                            `
                                <div style="min-width: 6rem">
                                    <div style='${styleText}'>
                                        ${data[data.length - 1]}
                                    </div>
                                </div>
                            `;

                            return html;
                        }
                    },
                    series: [
                        {
                            type: 'custom',
                            coordinateSystem: 'bmap',
                            renderItem: this.renderItem4,
                            itemStyle: {
                                color: "rgba(255,255,255, 0)",
                                borderColor: "rgba(255, 255, 255, 1)",
                                borderWidth: 2
                            },
                            animation: true,
                            silent: true,
                            data: [0],
                            z: -10
                        },
                        {
                            type: 'custom',
                            coordinateSystem: 'bmap',
                            renderItem: this.renderItem5,
                            itemStyle: {
                                color: "rgba(255,255,255, 0)",
                                borderColor: "rgba(255, 255, 255, 1)",
                                borderWidth: 2
                            },
                            animation: true,
                            silent: true,
                            data: [0],
                            z: -10
                        },
                        {
                            type: "effectScatter",
                            coordinateSystem: "bmap",
                            data: seriesNodeData,
                            symbol: "image://https://s3.bmp.ovh/imgs/2022/06/23/4664a0100da98724.png",
                            symbolSize: 15,
                            label: {

                                show: false,
                                position: 'top',
                                formatter: function (params) {
                                    return params.data[4]
                                    // return `
                                    //     {styleText|params.data[4]}
                                    // `
                                }
                            },
                            emphasis: {
                                disabled: false,
                                scale: 3,
                                focus: "self"
                            }
                        },
                          { type: "scatter",
                            coordinateSystem: "bmap",
                            data: coreData,
                            symbol: "image://https://s3.bmp.ovh/imgs/2022/06/28/f8267bfc2cf4df96.png",
                            symbolSize: 500,
                            selectedMode: true,
                            select: {
                                disabled: true
                            },
                            z: -20},
                         { type: "scatter",
                            coordinateSystem: "bmap",
                            data: coreData,
                            symbol: "image://https://s3.bmp.ovh/imgs/2022/06/21/850cf1c5408d363f.png",
                            symbolSize: 50,
                            selectedMode: true,
                            select: {
                                disabled: true
                            },
                            z: -20
                        },
                        {
                            type: 'custom',
                            coordinateSystem: 'bmap',
                            renderItem: this.renderItem,
                            itemStyle: {
                                color: "rgba(150, 255, 185, 0.28)",
                                borderColor: "rgba(150, 255, 185, 1)",
                                borderWidth: 2
                            },
                            animation: false,
                            silent: true,
                            data: [0],
                            z: -10,
                            label: {
                                normal: {
                                    show: true
                                }
                            }
                        },
                        {
                            type: 'custom',
                            coordinateSystem: 'bmap',
                            renderItem: this.renderItem1,
                            itemStyle: {
                                color: "rgba(150, 255, 185, 0.28)",
                                borderColor: "rgba(150, 255, 185, 1)",
                                borderWidth: 2
                            },
                            animation: false,
                            silent: true,
                            data: [0],
                            z: -10
                        },
                        {
                            type: 'custom',
                            coordinateSystem: 'bmap',
                            renderItem: this.renderItem2,
                            itemStyle: {
                                color: "rgba(150, 255, 185, 0.28)",
                                borderColor: "rgba(150, 255, 185, 1)",
                                borderWidth: 2
                            },
                            animation: false,
                            silent: true,
                            data: [0],
                            z: -10
                        },
                        {
                            type: 'custom',
                            coordinateSystem: 'bmap',
                            renderItem: this.renderItem3,
                            itemStyle: {
                                color: "rgba(150, 255, 185,  0.28)",
                                borderColor: "rgba(150, 255, 185, 1)",
                                borderWidth: 2
                            },
                            animation: true,
                            silent: true,
                            data: [0],
                            z: -10
                        },
                        
                    ]
                };
            },
            
            
            updateMap(option) {

                option && this.chart.setOption(option);

                const { type } = this.tOption;


                this.chart.getZr().off("click");

                this.chart.getZr().on("click", params => {

                    const { topTarget } = params;
                    // console.log(params, '****************');

                    if (!topTarget) {
                        this.updateShowZoon(false)
                        return;
                    }

                    if (type !== 1) {
                        this.updateShowZoon(false)
                        return;
                    }

                    if (topTarget.name) {

                        let [ name, desc ] = topTarget.name.split("-"); 
                        if(name == '新兴高端制造片区') {
                            desc = '大力发展智能网联与新能源汽车整车及零部件制造、生物医药、都市消费等产业。'
                        }
                        if(name == "南沙区1" || name == "南沙区2") {
                            this.updateShowZoon(false)
                            return;
                        }

                        let zoneData = {
                            name: name,
                            desc: desc,
                            x: params.offsetX,
                            y: params.offsetY
                        }
                        // console.log('7777', zoneData);
                        this.updateShowZoon(true)
                        this.updatazoneData(zoneData)
                        // this.$message({
                        //     message: `
                        //         <div>
                                    
                        //             <div
                        //                 style='color: #71FFA3 !important; border-left: 4px solid #71FFA3 !important;padding-left: 0.5rem !important'
                        //             >
                        //                 ${name}
                        //             </div>
                        //             <br />
                        //             <div
                        //                 style='color: #FFFFFF !important; padding-left: 0.5rem !important; line-height: 1.2rem !important'
                        //             >
                        //                 ${desc}
                        //             </div>
                        //         </div>
                        //     `,
                        //     duration: 0,
                        //     showClose: true,
                        //     iconClass: "element-ui-custom-icon",
                        //     customClass: "element-ui-custom-message",
                        //     dangerouslyUseHTMLString: true
                        // });
                    
                    } else {
                        this.updateShowZoon(false)
                    }
                });
                
                this.chart.off("bmaproam");
                this.resetInterval();

                if (type !== 3) {
                    this.chart.on("bmaproam", this.bmaproamHandler);
                }
                this.mapModel = this.chart.getModel().getComponent('bmap').getBMap();

                this.mapModel.addControl(new BMap.NavigationControl());
            },
            determineWhichOption() {

                let option = null;

                const { type } = this.tOption;

                switch(type) {
                    case 1:

                        option = this.getAreaOption();
                        break;
                    case 2:

                        option = this.getPlatformOption();
                        break;
                    case 3:

                        option = this.getAxisOption();
                        break;
                    case 4:

                        option = this.getEnterpriseOption();
                        window.labelOption = option
                        break;
                }

                return option;
            },
            updateMapHelper() {

                let option = this.determineWhichOption();
                if(option.series[2].label && option.series[2].label.show) {
                    option.series[2].label.show = false
                }
                

                this.chart.clear();

                this.updateMap(option);
            },
            renderItemHelper(coords, params, api, name, desc="") {

                const points = coords?.map(coord => api.coord(coord).concat(name));

                return {
                    type: 'polygon',
                    name: `${name}-${desc}`,
                    shape: {
                        points: this.$echarts.graphic.clipPointsByRect(points, {
                            x: params.coordSys.x,
                            y: params.coordSys.y,
                            width: params.coordSys.width,
                            height: params.coordSys.height
                        }),
                        smooth: 0.3
                    },
                    style: api.style()
                };
            },
            renderItem(params, api) {

                if (!this.areaData) {
                    return;
                }
                
                const coords = this.areaData[0]?.path;
                
                return this.renderItemHelper(coords, params, api, this.areaData[0]?.name, this.areaData[0]?.desc);
            },
            renderItem1(params, api) {

                if (!this.areaData) {
                    return;
                }
                
                const coords = this.areaData[1]?.path;
                
                return this.renderItemHelper(coords, params, api, this.areaData[1]?.name, this.areaData[0]?.desc);
            },
            renderItem2(params, api) {

                if (!this.areaData) {
                    return;
                }
                
                const coords = this.areaData[2]?.path;
                
                return this.renderItemHelper(coords, params, api, this.areaData[2]?.name, this.areaData[2]?.desc);
            },
            renderItem3(params, api) {

                if (!this.areaData) {
                    return;
                }
                
                const coords = this.areaData[3]?.path;
                
                return this.renderItemHelper(coords, params, api, this.areaData[3]?.name, this.areaData[3]?.desc);
            },
             renderItem4(params, api) {

                if (!this.nanshaData) {
                    return;
                }
                console.log(this.nanshaData, '*******************111111');
                const coords = this.nanshaData[0]?.path;
                
                return this.renderItemHelper(coords, params, api, this.nanshaData[0]?.name);
            },
             renderItem5(params, api) {

                if (!this.nanshaData) {
                    return;
                }
                
                const coords = this.nanshaData[1]?.path;
                
                return this.renderItemHelper(coords, params, api, this.nanshaData[1]?.name);
            },
            showTipSelected(option) {
                // this.isClickTooltip = false
                console.log(option, '-----123');
                // 隐藏南沙区
                option.series.shift()
                option.series.shift()
                this.chart.setOption(option)
                this.chart.dispatchAction({
                    type: "showTip",
                    seriesIndex: 0,
                    dataIndex: 0
                });

                this.chart.dispatchAction({
                    type: "highlight",
                    seriesIndex: 0,
                    dataIndex: 0
                });
            },
            timeoutHandler(times) {

                setTimeout(() => {

                    this.hideTipAndDownplaySelected(this.app.currentIndex);

                    this.resetInterval();
                }, times);
            },
            hideTipAndDownplaySelected(appCurrentIndex) {

                this.chart.dispatchAction({
                    type: 'hideTip',
                    seriesIndex: 0,
                    dataIndex: appCurrentIndex
                });

                this.chart.dispatchAction({
                    type: 'downplay',
                    seriesIndex: 0,
                    dataIndex: appCurrentIndex
                });
            },
            hideTipAndDownplay() {

                this.chart.dispatchAction({
                    type: 'hideTip',
                    seriesIndex: 0,
                    dataIndex: 0
                });

                this.chart.dispatchAction({
                    type: 'downplay',
                    seriesIndex: 0,
                    dataIndex: 0
                });
            },
            resetInterval() {
                clearInterval(this.tmpInterval);
                this.tmpInterval = undefined;
            },
            startInterval(dataLen, times) {

                this.app.currentIndex = -1;

                this.tmpInterval = setInterval(() => {

                    console.log('setInterval');

                    this.app.currentIndex = (this.app.currentIndex + 1) % dataLen;

                    // 高亮当前图形
                    this.chart.dispatchAction({
                        type: 'highlight',
                        seriesIndex: 0,
                        dataIndex: this.app.currentIndex,
                    });

                    // 显示 tooltip
                    this.chart.dispatchAction({
                        type: 'showTip',
                        seriesIndex: 0,
                        dataIndex: this.app.currentIndex
                    });
                }, times);
            },
            bmaproamHandler() {
                // this.resetInterval();

                const option = this.chart.getOption();

                const { zoom } = option.bmap[0];

                console.log(option, '===============');

                
                // else {
                    // let option2 = window.labelOption
                    // window.labelOption.series[2].label.show = true
                    // console.log('bbb', option2)
                    // this.chart.setOption(option2)
                // }

                const bmapModel = this.chart.getModel().getComponent("bmap").getBMap();

                const { data } = this.determineWhichOption().series[0];

                const updatedData = data.filter(el => {
                    if(el == 0) return
                    const [ x, y ] = el;

                    const point = new BMap.Point(x, y);

                    return BMapLib.GeoUtils.isPointInRect(point, bmapModel.getBounds())
                });
                const coreData = this.axisData?.map(el => this.updateDataHelper(el));
                option.series[0].data = updatedData;
                console.log(option.series, '1111');
                if (zoom > 11) {
                    option.series[2].label.show = true
                    option.series[3].data = [0]
                    option.series[4].data = [0]
                    this.updateShowZoon(false)
                } else if(zoom < 11) {
                    // console.log(zoom, '111111111111111111');
                    option.series[3].data = [0]
                    option.series[4].data = [0]
                    this.updateShowZoon(false)
                }
                else {
                    option.series[2].label.show = false
                    option.series[3].data = coreData
                    option.series[4].data = coreData

                }
                option.series[0].data = [0]
                // console.log(option.series[3].data,zoom, '00000');
                this.chart.setOption(option);

                const { length } = option.series[0].data;

                const defaultTimes = 2000;

                // this.startInterval(length, defaultTimes);

                this.timeoutHandler(defaultTimes * (length + 1));
            },
            calculatePosition(point, params, dom, rect, size) {

                // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
                            
                // 提示框位置
                let x = 0; // x坐标位置
                let y = 0; // y坐标位置
 
                // 当前鼠标位置
                const pointX = point[0];
                const pointY = point[1];

                // 提示框大小
                const boxWidth = size.contentSize[0];
                const boxHeight = size.contentSize[1];

                // boxWidth > pointX 说明鼠标左边放不下提示框
                if (boxWidth > pointX) {
                    x = pointX + 10;
                } else { // 左边放的下
                    x = pointX - boxWidth-10;
                }

                // boxHeight > pointY 说明鼠标上边放不下提示框
                if (boxHeight > pointY) {
                    y = 5;
                } else { // 上边放得下
                    y = pointY - boxHeight;
                }

                return [x, y];
            }
        },
        watch: {
            tOption: {
                deep: true,
                immediate: true,
                handler(val) {

                    if (!val || !this.chart) {
                        return;
                    }

                    this.updateMapHelper();
                }
            },
            tData: {
                deep: true,
                immediate: true,
                 handler(val) {

                   console.log(val,'---------------');
                //    this.startInterval()
                }
            }
            ,
            selectedPlatform: {
                immediate: true,
                deep: true,
                handler(val) {

                    if (!val) {
                        return;
                    }

                    this.chart.clear();

                    const option = this.getPlatformOption([val]);
                    option.series[2].label.show = false

                    this.updateMap(option);

                    this.showTipSelected(option);
                }
            },
            selectedEnterprise: {
                immediate: true,
                deep: true,
                handler(val) {

                    if (!val) {
                        return;
                    }

                    this.chart.clear();

                    const option = this.getEnterpriseOption([val]);
                    option.series[2].label.show = false

                    this.updateMap(option);

                    this.showTipSelected(option);
                }
            },
            enterpriseData: {
                deep: true,
                handler(val) {

                    if (!val) {
                        return;
                    }

                    this.updateMapHelper();
                }
            },
            areaData: {
                deep: true,
                handler(val) {

                    if (!val) {
                        return;
                    }

                    this.updateMapHelper();
                    // this.showTipSelected();
                }
            },
            nanshaData: {
                deep: true,
                handler(val) {
                    if(!val) {
                        return;
                    }
                    this.updateMapHelper();
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

    #geo-map {
        width: 96%;
        height: 350px;
        position: relative;
        left: 50%;
        top: 80%;
        margin-top: 10rem;
        margin-bottom: -11rem;
        transform: translate(-50%, -50%);
    }

    #info {
        color: white;
    }
</style>

<style lang="scss">

    .element-ui-custom-icon {
        display: none !important;
    }

    .element-ui-custom-message {
        // color: #71FFA3 !important;
        background-color: rgba($color: #000000, $alpha: 0.5);
        border: none !important;
        border-radius: 0;
        // border-left: 4px solid #71FFA3 !important;
        position: fixed !important;
        top: 20% !important;
    }
    
</style>